var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVegasDesh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 576 75",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    fillOpacity: 1,
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M62.3 22.75C58.97 8.75 56.71 0 56.71 0S47.88 2 33.9 5.31c-7.37 1.77-24.63 6.8-31.54 18.07a16 16 0 0020.91 22.55 1.79 1.79 0 011.39.12 1.361 1.361 0 01.59 1.89c-3 3.73-11.44 12.32-22.51 10.18l26.58 16.31c-6.93-8.91-3.08-20.29-1.11-24.67a1.348 1.348 0 011.95-.34c.402.275.667.708.73 1.19a16.001 16.001 0 0029.58 8.43c6.94-11.26 3.6-28.92 1.83-36.29zM42.82 36.09l-3.28 13.64-5.34-13-14 1.1 10.62-9.06-5.36-13 12 7.34 10.66-9.1-3.3 13.66 12 7.33z",
    fill: "#fbc010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-1",
    d: "M83.04 52.32h12.69v4.48H83.04v11.78h-5.47v-28.5h18.84v4.68H83.04z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M123.66 40.08v20.25c0 7.94-5 8.48-11.9 8.48-6.68 0-11.81-.5-11.81-8.48V40.08h5.47v20.25c0 2.93 1.06 3.8 6.34 3.8 5.06 0 6.43-.72 6.43-3.8V40.08zm-13.84-6.5v3.35h-3.76v-3.35zm7.75 0v3.35h-3.75v-3.35z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M133.16 59.16v9.42h-5.47v-28.5h14.55c6.23.15 8.62 2.09 8.62 8.55 0 4.22-.22 7.3-5.05 8v.15c3.88.34 4.83 2.43 4.83 6.46v5.34h-5.47v-5.32c0-2.39-1-4.07-3.61-4.1zm7.22-4.68c4 0 5-.8 5-5s-.72-4.75-4.63-4.75h-7.6v9.72z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    d: "M169.87 59.5v1.33c0 3.26 1.4 3.49 6.46 3.49 5.06 0 5.66-.91 5.66-4.21 0-4.07-2.17-3.54-6.42-3.77-6.16-.38-11-.15-11-8.43 0-7.83 4.94-8.06 11.78-8.06 5.81 0 10.56.19 10.56 7.68v.91h-5.49v-.86c0-3.08-1.26-3.19-5.09-3.19-5.44 0-6.31.53-6.31 3.57 0 3.49.72 3.61 6.27 3.95 8.77.53 11.17 1 11.17 8.25 0 8-3.8 8.7-11.13 8.7-6.31 0-11.93.19-11.93-8v-1.33z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    d: "M215.42 68.58h-5.47V56.42h-13.26v12.16h-5.47v-28.5h5.47v11.67h13.26V40.08h5.47z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M82.96 19.91v1.33c0 3.26 1.4 3.49 6.46 3.49 5.06 0 5.66-.91 5.66-4.21 0-4.07-2.17-3.54-6.42-3.77-6.16-.38-11-.15-11-8.43C77.66.49 82.6.26 89.44.26 95.25.26 100 .45 100 7.94v.91h-5.47v-.91c0-3.08-1.25-3.19-5.09-3.19-5.44 0-6.31.53-6.31 3.57 0 3.49.72 3.61 6.27 3.95 8.78.53 11.17 1 11.17 8.25 0 8-3.8 8.7-11.13 8.7-6.31 0-11.93.19-11.93-8v-1.33z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    d: "M128.52 28.99h-5.47V16.83h-13.23v12.16h-5.48V.49h5.48v11.67h13.26V.49h5.47z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    d: "M132.29.49h12.61c7.64 0 10.14 1.82 10.14 9.8s-2.69 9.46-10.14 9.46h-7.14v9.23h-5.47zm12.61 14.59c3.91-.08 4.67-.8 4.67-4.79s-.57-5.17-4.67-5.13h-7.14v9.92z",
    fill: "#f9be12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    d: "M181.91 10.67v7.68c0 9.11-3.53 10.86-12.16 10.86-8.81 0-12-1.52-12-10.86v-7.68c0-8.85 3-10.41 12-10.41 8.21 0 12.16 1.25 12.16 10.41zm-18.73 0v7.68c0 5.66 1.1 6.19 6.57 6.19 5 0 6.69-.68 6.69-6.19v-7.68c.11-5.36-1.82-5.74-6.69-5.74-5.93 0-6.46 1.22-6.57 5.74z",
    fill: "#f9be12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    d: "M190.62 12.11h2.54l9.5-11.62h6.72l-11.56 13.9 12.73 14.59h-6.91l-10.49-12.19h-2.53v12.19h-5.48V.49h5.48z",
    fill: "#f9be12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    d: "M217.41 12.27h13.33v4.48h-13.33v7.56h14.17v4.67h-19.65V.49h19.53v4.67h-14.05z",
    fill: "#f9be12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    d: "M241.12 19.58V29h-5.47V.49h14.55c6.23.15 8.62 2.09 8.62 8.55 0 4.21-.23 7.29-5.05 8v.16c3.87.34 4.82 2.43 4.82 6.45v5.32h-5.47v-5.32c0-2.39-1-4.06-3.61-4.1zm7.22-4.67c4 0 5-.8 5-5 0-4-.72-4.75-4.63-4.75h-7.6v9.73z",
    fill: "#f9be12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    d: "M267.49 19.9v1.33c0 3.27 1.4 3.5 6.46 3.5 5.06 0 5.66-.91 5.66-4.22 0-4.06-2.17-3.53-6.42-3.76-6.16-.38-11-.15-11-8.44 0-7.82 4.94-8.05 11.78-8.05 5.81 0 10.56.19 10.56 7.68v.91h-5.47v-.91c0-3.08-1.26-3.2-5.09-3.2-5.44 0-6.31.53-6.31 3.57 0 3.5.72 3.61 6.27 4 8.78.53 11.17 1 11.17 8.24 0 8-3.8 8.7-11.13 8.7-6.31 0-11.93.19-11.93-8v-1.33z",
    fill: "#f9be12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-14",
    d: "M300.24 28.98h-5.42V5.16h-8.36V.49h22.19v4.67h-8.36z",
    fill: "#f9be12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-15",
    d: "M312.17 23.58l-1.78 5.39h-5.66L314.19.48h8.05l9.65 28.49h-5.54l-1.86-5.39zm6.2-18.92h-.08l-4.86 14.78h9.84z",
    fill: "#f9be12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-16",
    d: "M340.33 19.58V29h-5.51V.49h14.55C355.6.64 358 2.58 358 9.04c0 4.21-.23 7.29-5.05 8v.16c3.87.34 4.82 2.43 4.82 6.45v5.32h-5.47v-5.32c0-2.39-1-4.06-3.61-4.1zm7.22-4.67c4 0 5-.8 5-5 0-4-.73-4.75-4.64-4.75h-7.6v9.73z",
    fill: "#f9be12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-17",
    d: "M366.7 19.9v1.33c0 3.27 1.41 3.5 6.46 3.5s5.66-.91 5.66-4.22c0-4.06-2.16-3.53-6.42-3.76-6.15-.38-11-.15-11-8.44 0-7.82 4.93-8.05 11.77-8.05 5.82 0 10.57.19 10.57 7.68v.91h-5.48v-.91c0-3.08-1.25-3.2-5.09-3.2-5.43 0-6.3.53-6.3 3.57 0 3.5.72 3.61 6.27 4 8.77.53 11.17 1 11.17 8.24 0 8-3.8 8.7-11.14 8.7-6.3 0-11.93.19-11.93-8v-1.33z",
    fill: "#f9be12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-18",
    d: "M424.82.43l-9.25 28.55h-8.34L398.07.43h5.63l5.35 16.15c.43 1.2 1.46 4.75 2.28 7.74h.13c1.33-4.79 1.5-5.39 2.28-7.74L419.03.4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-19",
    d: "M432.18 12.37h13.38v4h-13.38v8.05h14.24v4.54h-19.74V.43h19.61v4.54h-14.11z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-20",
    d: "M473.68 13.83c.08 1.45.08 2.48.08 4.92 0 4.88-.43 6.63-2 8.22-1.73 1.79-4 2.26-10.8 2.26-3.91 0-5.67-.21-7.35-.89-3.7-1.55-5-4.28-5-10.88 0-7.49.09-9.16.65-11.25a7.43 7.43 0 015.46-5.52c1.33-.39 3.23-.52 6.84-.52 5.89 0 7.35.22 9.28 1.37 1.93 1.15 2.67 3.17 2.76 7.45h-5.55c-.17-3.81-.86-4.24-6.79-4.24-4.13 0-5.59.47-6.37 2.06-.56 1.19-.69 2.52-.69 7.7 0 5.39.13 7 .65 8.09.73 1.58 2.32 2.05 6.79 2.05 3.14 0 4.73-.3 5.46-1 .73-.7 1.12-2.27 1.12-4.58 0-.13 0-.64-.08-1.16h-7.18v-4.06z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-21",
    d: "M481.72 23.5l-1.76 5.48h-5.77L483.74.43h8.13l9.71 28.55h-5.63l-1.85-5.48zm6.19-18.92l-4.9 14.81h9.81z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-22",
    d: "M519.26 8.78v-.52c0-3.12-.91-3.77-5.34-3.77-5.2 0-6.23.65-6.23 3.9 0 2.05.52 3 1.89 3.42.73.22 1 .22 5.46.47 4.82.3 6.45.6 7.83 1.59 1.76 1.2 2.36 2.87 2.36 6.5s-.51 5.48-1.76 6.72c-1.72 1.67-3.91 2.14-9.89 2.14-5.2 0-7-.3-8.86-1.41a5.437 5.437 0 01-2.28-3.51 21.528 21.528 0 01-.34-4.36h5.29c0 2.14.13 2.86.6 3.59.69 1.16 1.38 1.29 5.85 1.29 3.22 0 4.13-.13 4.94-.77.81-.64 1-1.63 1-3.6 0-1.97-.43-2.78-1.59-3.17-.68-.25-.68-.25-5.46-.55-4.78-.3-5.93-.48-7.39-1.16-2.28-1.11-3.18-3.17-3.18-7.1 0-3.39.73-5.48 2.28-6.6 1.76-1.32 4-1.71 9.33-1.71s7.69.56 9.11 2.14c1.12 1.24 1.64 3 1.64 5.44v1z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-23",
    d: "M532.63 28.98h-4.81v-5.22h4.77z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-24",
    d: "M554.26 28.98h-4.73l.17-3.21-.09-.05c-1 2.57-2.66 3.51-6.14 3.51-2.76 0-4.78-.64-6-1.88-1.46-1.54-1.85-3.38-1.85-8.73 0-4.5.43-6.34 1.81-7.92 1.11-1.33 3-2 5.89-2 3.39 0 5.11.9 6 3.13h.09V.43h4.86zM540.54 18.7c0 5.65.69 6.77 4.3 6.77 3.91 0 4.56-1 4.56-6.89 0-4.93-.82-6-4.6-6-3.57 0-4.26 1-4.26 6.12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-25",
    d: "M575.93 22.58c0 5.09-2 6.63-8.64 6.63-8 0-9.85-1.88-9.85-10.35 0-4.37.47-6.51 1.76-8 1.29-1.49 3.66-2.19 7.7-2.19 5.25 0 7.48 1.16 8.51 4.33.43 1.41.52 2.39.52 6.8h-13.59v.77c0 4.07.86 5 4.56 5 3.53 0 4.17-.47 4.21-3zm-4.77-6.51c-.09-3.16-.73-3.76-4.35-3.76-2.62 0-3.57.34-4.08 1.58a8.094 8.094 0 00-.35 2.95h8.78z",
    fill: "#fff"
  }))));
}
SvgVegasDesh.displayName = 'VegasDesh';
export default SvgVegasDesh;